import Disclaimer from "../../../Disclaimer";
import Icon from "../../../Icon";
import TextInput from "../../../TextInput";
import cn from "classnames";
import style from "./Shipped.module.sass";
import { UseApi } from "../../../../hooks/use-api";
import { ShipHistory, ShipLabel } from "../../../../Services/lib/shipping";
import { useEffect, useState } from "react";
import { statuses__ } from "..";
import { ToastEmitter } from "../../../../Services/assets/toast-emitter";
import nft_product from "../../../../i11/Nft_Product";
import { useUser } from "../../../../context";

const Shipped = ({ item }) => {
	const { locale } = useUser();
	const [base64Image, setImage] = useState(null);
	const [{ data }, fetch] = UseApi({
		service: ShipHistory,
	});

	const [{ data: label }, fetchLabel] = UseApi({
		service: ShipLabel,
	});

	const download = () => {
		if (!label) {
			ToastEmitter({
				msg: "Please wait. The label did not download yet",
			});
			return;
		}
		var a = document.createElement("a");
		a.href = "data:image/png;base64," + base64Image;

		a.download = item?.name + "_image.png";
		a.click();
	};

	const init = async () => {
		fetch(item._id);
		const res = await fetchLabel(item._id);
		if (res) {
			const packageRes =
				res?.response?.ShipmentResponse.ShipmentResults?.PackageResults;
			if (packageRes && packageRes.length >= 1) {
				setImage(packageRes[0]?.ShippingLabel?.GraphicImage);
			} else if (typeof packageRes === "object") {
				setImage(packageRes?.ShippingLabel?.GraphicImage);
			}
		}
	};

	useEffect(() => {
		init();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<Disclaimer className={style.disclaimer}>
				{data?.map((e) => {
					const date = new Date(e.statusUpdated);
					return (
						<div key={e._id}>
							<p className={style.statuses}>
								{e.user?.userName}{" "}
								{statuses__[e.redeemNftStatus]?.toLowerCase()}{" "}
								product at {date.toLocaleString()}
							</p>
						</div>
					);
				})}
			</Disclaimer>
			<div className={style.flex__}>
				<div className={style.flex}>
					<a
						className={cn(style.item, style.withHover)}
						target="_blank"
						href={`https://wwwapps.ups.com/etracking/tracking.cgi?TypeOfInquiryNumber=T&InquiryNumber1=${item.shipment.TrackingNumber}&requester=ST/trackdetails`}
						rel="noreferrer"
					>
						<TextInput
							label={nft_product[locale].track}
							disabled
							value={item.shipment.TrackingNumber}
						/>
						<div className={style.icon}>
							<Icon reicon="externalLink" size="18" />
						</div>
					</a>
				</div>
				{base64Image && (
					<div className={style.img1}>
						<div className={style.img2}>
							<img
								className={style.img}
								src={`data:image/png;base64,${base64Image}`}
								alt="shipping label"
							/>
						</div>
						<button onClick={download} className="button-small">
							{nft_product[locale].download}
						</button>
					</div>
				)}
			</div>
		</div>
	);
};

export default Shipped;
